import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { isLoginComplete } from '../services/authService';

/**
 * AuthGuard ΓÇö login required before protected routes.
 */
const AuthGuard = ({ isAuthenticated, bootstrapped, loading, children }) => {
  const location = useLocation();

  if (!bootstrapped || loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f5f5f5',
        }}
      >
        <div className="text-center">
          <div className="spinner-border text-success" role="status" />
          <p className="mt-3 text-muted mb-0">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !isLoginComplete()) {
    return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
  }

  return children;
};

AuthGuard.propTypes = {
  isAuthenticated: PropTypes.bool,
  bootstrapped: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

AuthGuard.defaultProps = {
  isAuthenticated: false,
  bootstrapped: false,
  loading: false,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  bootstrapped: state.auth.bootstrapped,
  loading: state.auth.loading,
});

export default connect(mapStateToProps)(AuthGuard);
